import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';

class ErrorMessage extends PureComponent {
    render() {
        const { children, isWarning } = this.props;

        return (
            <div className={`kbe-message ${isWarning ? 'kbe-warning-message' : 'kbe-error-message'} `}>
                <Icon name="CircleNotice" className="kbe-margin-right-small" fill="rgba(255, 255, 255, .87)" />
                {children}
            </div>
        );
    }
}

ErrorMessage.defaultProps = { isWarning: false };

ErrorMessage.propTypes = {
    isWarning : PropTypes.bool,
    children  : PropTypes.node.isRequired,
};

export default ErrorMessage;
